import React from "react";
import styled, { ThemeProvider } from "styled-components";
import { Helmet } from "react-helmet";
import { GlobalStyle } from "./global-style";
import { theme } from "../theme";
import { Header } from "./header";
import { Footer } from "./footer";

const PageContainer = styled.div`
  background: ${(props) => props.theme.colours.background};
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  justify-content: space-between;
`;

export const Layout = ({ children }) => {
  return (
    <>
      <Helmet>
        <link rel="stylesheet" href="https://use.typekit.net/fdd4ucu.css" />
      </Helmet>
      <ThemeProvider theme={theme}>
        <>
          <GlobalStyle />
          <PageContainer>
            <Header />
            <main>{children}</main>
            <Footer />
          </PageContainer>
        </>
      </ThemeProvider>
    </>
  );
};
